import AttachedNewProofOfTaxSituationSuccessfully from './attached-new-proof-of-tax-situation-successfully.json';

export default {
  'document-validation': {
    ...AttachedNewProofOfTaxSituationSuccessfully,
  },
};
